import { fromEvent, from, of, EMPTY } from 'rxjs';
import * as Rx from 'rxjs'
import { filter, map, mergeMap, scan, merge, withLatestFrom, groupBy, skip, pairwise, skipUntil,
  startWith, tap, delay, combineLatest, switchMap, distinctUntilChanged, take, share } from 'rxjs/operators';
import _ from 'lodash'
// import { gql } from 'apollo-boost';
import { Dispatch } from 'architecture'

import { gql } from 'apollo-boost';
import client from '../apollo';

import { stateRefreshStream } from './functions'


const UPSERT_TEXT_INSTANCE = gql`
  mutation createTextInstance($object: String, $text: String!, $tags: [String!]) {
    createTextInstance(object: $object, text: $text, tags: $tags) {
      success
    }
  }
`;

const upsertText$ = (object, text, tags) => {
    const tagKeys = tags ? Object.keys(tags) : []
    return from(client.mutate({
      mutation: UPSERT_TEXT_INSTANCE,
      variables: {object, text, tags: tagKeys },
  }))
}

const typeObjects = {
  textInstance: {
    value: ''
  }
}

const getTypeObject = (type) => {
  
  return typeObjects.type
}

Rx.merge(

  // Update a value into a buffer (does not save it but may display it)
  // Accepts { stateId, name, value, type }
  Dispatch.getAction('buffer', 'update')
    .pipe(
      map(e => (acc) => ({...acc, [e.stateId]: { ...acc[e.stateId], [e.name]: e.value, type: e.type }}))
    ),

  // Create a blank buffer of a "type"
  // Accepts { stateId, type }
  Dispatch.getAction('buffer', 'create')
    .pipe(
      map(e => (acc) => ({...acc, [e.stateId]: getTypeObject(e.type)}))
    ),

  // Removes all changes to a buffer
  // Accepts stateId
  Dispatch.getAction('buffer', 'cancel')
    .pipe(
      map(stateId => (acc) => {
        const newAcc = _.cloneDeep(acc)
        delete newAcc[stateId]
        return newAcc
      })
    ),

  // Saves and removes item from buffer
  // Accepts stateId
  Dispatch.getAction('buffer', 'save')
    .pipe(
      // Hack to make blur update text before save is fired...needs to be fixed.
      delay(10),
      groupBy(stateId => stateId),
      mergeMap(group => group
        .pipe(
          withLatestFrom(Dispatch.getState('States.' + group.key)),
          switchMap(([save, state]) => {
            let stream$ = EMPTY
            if (state.instance.__typename === 'TextInstance'){
              stream$ = upsertText$(state.object.id, state.instance.text, null)
            }
            return Rx.merge(stream$)
              .pipe(
                mergeMap(e => stateRefreshStream()),
                filter(e => e === false),
              )
          }),

          // wait for raw response
          map(response => (acc) => {
            const newAcc = _.cloneDeep(acc)
            delete newAcc[group.key]
            return newAcc
          }),
          // Add startiwth for pending save
          startWith( (acc) => ({...acc, [group.key]: { ...acc[group.key], saving: true }}))
        )
      ),
    )

).pipe(
  scan((acc, next) => next(acc), {}),
  startWith({})
)
.subscribe(e => Dispatch.nextState('buffer', e))
  

// Save needs to save
// wait for next rawstate
// remove from buffer



//Dispatch.nextAction('buffer', 'update', { stateId: "cjsvfs3o7026y08705fzqb0v1", name: "text", value: "hiiiii", type: 'textInstance' })

// Dispatch.getAction('task', 'save')
//   .pipe(
//     withLatestFrom(Dispatch.getState('States')),
//     switchMap(([save, states]) => from(client.mutate({
//       mutation: CREATE_TASK_INSTANCE,
//       variables: { 
//         object: states[save.stateId].object.id, 
//         tags: {}, 
//         description: states[save.stateId].instance.description, 
//         status: states[save.stateId].instance.status, 
//         due: new Date(states[save.stateId].instance.dueDate), 
//         name: '', 
//       },
//     }))
//     .pipe(
//       //map(e => e[0]),
//       //combineLatest(Dispatch.getState('States').pipe(skip(1))),
//       tap(e => Dispatch.mergeState('TaskBuffer.' + save.stateId, { saved: true })),
//       //startWith({})
//     )
//   ),
//     // withLatestFrom(Dispatch.getState('TaskBuffer')),
//     // map(([update, buffer]) => remove(buffer, update.id))
//   )
//   .subscribe(e => {
//     //Dispatch.nextState('TaskBuffer.' + e.id, e)
//     Dispatch.nextAction('Instance', 'created')
//   })